<template>
  <v-container fluid pa-0 class="requestsContainer">
    <v-flex xs12 style="font-size: 36px; font-weight: 700">
      Requests
    </v-flex>
    <v-card style="margin-top: 60px; background-color: transparent !important" class="elevation-0">
      <v-tabs hide-slider>
        <v-tab :ripple="false" key="tab-1">
          Subscription Requests
        </v-tab>

        <v-tab :ripple="false" key="tab-2">
          Access Requests
        </v-tab>

        <v-tab :ripple="false" key="tab-3">
          Project Requests
        </v-tab>

        <v-tab-item key="tab-1">
          <v-card flat>
            <v-card-text>
              <br/><br/>
              <OrganizationSubscriptionRequests v-bind:options="{projects: projects}"></OrganizationSubscriptionRequests>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="tab-2">
          <v-card flat>
            <br/><br/>
            <v-card-text><OrganizationAccessRequests v-bind:options="{projects: projects}"></OrganizationAccessRequests></v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="tab-3">
          <v-card flat>
            <br/><br/>
            <v-card-text><OrganizationProjectRequests v-bind:options="{projects: projects}"></OrganizationProjectRequests></v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<style>
  .requestsContainer .v-tabs__bar{
    background-color: transparent !important;
  }
  .requestsContainer .v-tabs__item{
    background-color: #F2F3F5 !important;
    font-size: 18px;
    text-transform: capitalize;
    color: #738396;
  }
  .requestsContainer .v-tabs__item.v-tabs__item--active{
    background-color: white !important;
    color: #011E41;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import OrganizationSubscriptionRequests from '../organization/OrganizationSubscriptionRequests.vue'
import OrganizationAccessRequests from '../organization/OrganizationAccessRequests.vue'
import OrganizationProjectRequests from '../organization/OrganizationProjectRequests.vue'
import axios from 'axios'

export default {
  data () {
    return {
      projects: []
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getUserOrganization: 'getUserOrganization'})
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getData: function () {
      axios.all([this.$store.dispatch('getProjectsWithAllByOrganizationId', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.projects = response.data.payload
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted: function () {
    if (this.getUserOrganization) {
      this.getData()
    }
  },
  watch: {
    getUserOrganization: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData()
      }
    }
  },
  components: {
    OrganizationSubscriptionRequests,
    OrganizationAccessRequests,
    OrganizationProjectRequests
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationRequests.vue